'use strict';

var implementation = require('./implementation');

module.exports = function getPolyfill() {
	if (String.prototype.matchAll) {
		try {
			''.matchAll(RegExp.prototype);
		} catch (e) {
			return String.prototype.matchAll;
		}
	}
	return implementation;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/string.prototype.matchall/polyfill.js
// module id = 1184
// module chunks = 29